module.exports = __webpack_public_path__ + "static/media/SolitaireKlondikeTeaser.1d3ca2b9.jpg";